import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { UserProvider } from './contexts/UserContext';
import { ThemeProvider } from '@mui/material/styles';
import { GlobalStyles } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import darkTheme from './theme/darkTheme';

console.log('[BOOT] index.js: all imports resolved');

function Main() {
  console.log('[BOOT] Main: rendering provider tree');

  return (
      <React.StrictMode>
        <ThemeProvider theme={darkTheme}>
          <CssBaseline enableColorScheme />
          <GlobalStyles styles={{
            body: {
              backgroundColor: darkTheme.palette.background.default,
              color: darkTheme.palette.text.primary,
            }
          }} />
          <GoogleOAuthProvider clientId="481298175224-ksaddf22q5h9vun7pgqs8slno0m35hcr.apps.googleusercontent.com">
            <UserProvider>
                <App />
            </UserProvider>
          </GoogleOAuthProvider>
        </ThemeProvider>
      </React.StrictMode>
  );
}

console.log('[BOOT] index.js: calling ReactDOM.createRoot');
const root = ReactDOM.createRoot(document.getElementById('root'));
console.log('[BOOT] index.js: root.render starting');
try {
  root.render(<Main />);
  console.log('[BOOT] index.js: root.render() called OK');
} catch (e) {
  console.error('[BOOT] index.js: root.render() THREW: ' + e.message);
  console.error(e.stack);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
